import React from 'react';
import PropTypes from 'prop-types';
import {
    UserContext,
    JoinContext,
    ExperimentContext,
    DOMUtilsContext,
    VrboHandler
} from '../../contexts';

const LYPContext = ({ children, history }) => (
    // this history value is a problem
    // should be a context, but it is used in
    // pageflow, which is a class component, unable to use hooks
    <ExperimentContext history={history}>
        <UserContext history={history}>
            <JoinContext history={history}>
                <VrboHandler>
                    <DOMUtilsContext history={history}>
                        {children}
                    </DOMUtilsContext>
                </VrboHandler>
            </JoinContext>
        </UserContext>
    </ExperimentContext>
);

LYPContext.propTypes = {
    children: PropTypes.node.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired
};
LYPContext.displayName = 'LYPContext';

export default LYPContext;
